import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    new Swiper(this.element, {
      speed: 400,
      observer: true,
      observeParents: true,
      preloadImages: false,
      lazy: {
        loadPrevNext: false
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    })
  }
}
